import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output, Type, inject } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { GenericCrudAddComponent } from './generic-crud-add.component';
import { GenericCrudEditComponent } from './generic-crud-edit.component';
import { TabsService } from '../tabs-host/tabs.service';
import { IListableResource } from 'src/app/resources';
import { DxDataGridComponent } from 'devextreme-angular';
import { AlertService } from 'src/app/services/alert.service';

export interface IGenericCrudCreationContext {
  text: string,
  component?: Type<GenericCrudAddComponent<any>>,
  inputParams: {[key: string]: unknown},
  type?: number,
  enabled: boolean,  // Indicates if the creation is enabled in the generic crud
  eventEmitter?: Subject<any>,
}

export interface IGenericCrudEditionContext {
  text: string,
  component: Type<GenericCrudEditComponent<any>>,
  inputParams: {[key: string]: unknown},
  eventEmitter?: Subject<any>,
}

export interface IGenericCrudContext {
  search: {[key: string]: string},
  creation?: IGenericCrudCreationContext[],
  edition?: IGenericCrudEditionContext[],
}

export interface IDataGridReady {
  onDataGridReady(): void;
}

@Component({
    template: '',
    standalone: false
})
export abstract class GenericCrudContextComponent implements OnDestroy, AfterViewInit {

  ready$: Observable<boolean>;
  destroy$: Observable<void>;

  @Output() contextChange: EventEmitter<IGenericCrudContext>;
  @Output() contextItemChanges: EventEmitter<IGenericCrudContext>;
  @Input() resource?: IListableResource<any>;
  @Input() dataGrid?: DxDataGridComponent;

  // The default behavior for onCreate
  // This methods is usually overriden by the contextualizer,
  // but with this reference it can be called from the contextualizer
  defaultOnCreate?: (item: any) => void;

  private _ready$: BehaviorSubject<boolean>;
  private _destroy$: Subject<void>;

  protected tabs: TabsService;
  protected alerts: AlertService;
  fullyLoadedData$?: Observable<any[] |  undefined>;

  constructor() {
    this.tabs = inject(TabsService);
    this.alerts = inject(AlertService);
    this._ready$ = new BehaviorSubject<boolean>(false);
    this._destroy$ = new Subject<void>();
    this.ready$ = this._ready$;
    this.destroy$ = this._destroy$;
    this.contextChange = new EventEmitter();
    this.contextItemChanges = new EventEmitter();
  }

  ngAfterViewInit(): void {
    this.setReady();
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  protected setReady(): void {
    this._ready$.next(true);
  }

}
